import React, { useState } from "react";
import AppointmentCard from "./AppointmentCard";
import styled from "@emotion/styled";
import { getAllAppointments } from "../../../api/appointmentApi";
import { StyledDay, StyledMMDD } from "../../service-providers/styles";
import AppointmentFilterDashboard from "./AppointmentFilterDashboard";
import {
  toYYYYMMDD,
  getSlicedDay,
  getMMDD,
  getTime,
} from "../../../common/helpers/normalizeDateTime";

export const StyledAppointmentsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

const AppointmentsContainer = () => {
  const [appointments, setAppointments] = useState({});
  const [filterService, setFilterService] = useState("");
  const getPatientName = async (userId) => {
    let name = await getPatientName(userId);
    return name;
  };
  const getAppointments = async (
    serviceProviderId,
    dateFrom,
    dateTo,
    service
  ) => {
    setFilterService(service);
    const response = await getAllAppointments(
      serviceProviderId,
      dateFrom,
      dateTo
    );

    let filteredAppointments = {};
    response.map((data) => {
      let date = toYYYYMMDD(data.appointment.appointmentDateTime);
      var newAppointment = data.appointment;
      newAppointment["patientName"] = data.patientName;
      newAppointment["serviceName"] = data.serviceName;
      newAppointment["serviceProviderName"] = data.serviceProviderName;

      if (date in filteredAppointments) {
        filteredAppointments[date].push(newAppointment);
      } else {
        filteredAppointments[date] = [];
        filteredAppointments[date].push(newAppointment);
      }
    });
    console.log(filteredAppointments);
    setAppointments(filteredAppointments);
  };
  return (
    <div>
      <AppointmentFilterDashboard getAppointments={getAppointments} />
      <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
        {Object.entries(appointments).map(([key, value]) => {
          return (
            <div
              style={{
                width: "30%",
                padding: "5px",
                borderRadius: "10px",
                marginRight: "10px",
              }}
            >
              <StyledDay>{getSlicedDay(key)}</StyledDay>
              <StyledMMDD>{getMMDD(key)}</StyledMMDD>
              <StyledAppointmentsContainer>
                {value.map((appointment) => {
                  return (
                    <AppointmentCard
                      theme={
                        appointment.serviceName === "Consultation"
                          ? "lightpurple"
                          : "yellow"
                      }
                      time={getTime(appointment.appointmentDateTime)}
                      serviceName={appointment.serviceName}
                      serviceProviderName={appointment.serviceProviderName}
                      patientName={appointment.patientName}
                    />
                  );
                })}
              </StyledAppointmentsContainer>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AppointmentsContainer;
